"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "20", height: "20", viewBox: "0 0 20 20", className: "Icon cross-small", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("circle", { fill: "#E60B0B", cx: "10", cy: "10", r: "10" }),
            _react2.default.createElement(
                "g",
                { fill: "#FFF" },
                _react2.default.createElement("path", { d: "M13.293 5.293l-8 8 1.414 1.414 8-8z" }),
                _react2.default.createElement("path", { d: "M13.293 14.707l1.414-1.414-8-8-1.414 1.414z" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/cross-small.js
// module id = 1792
// module chunks = 0